module.exports = __webpack_public_path__ + "static/media/Competences_PictoCdlT.92fbaac2.png";